import React from "react";

const MyWorkspaceRoute = ({ children }) => {
    return children;
};

export default MyWorkspaceRoute;
